module.exports = __webpack_public_path__ + "img/logo-01.70560417.png";